import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';
import { IThunkRestoreDeEscalation, IClientDetailsStore, IClientDetailsActions } from '../types';

const onRestoreDeEscalation: IThunkRestoreDeEscalation = thunk(
  async ({ setClientDetails }: Actions<IClientDetailsActions>, payload, { getState }) => {
    const localState = getState() as IClientDetailsStore;

    await api.clientDetails.restoreDeEscalation(payload);

    const deEscalationTechniques = localState.deEscalationTechniques.map(item =>
      item.id !== Number(payload.id) ? item : { ...item, isArchived: false },
    );

    setClientDetails({ deEscalationTechniques });
  },
);

export default onRestoreDeEscalation;
